import { AxiosRequestConfig } from "axios";
import Constants from "expo-constants";
import qs from "qs";
import Cookies from "universal-cookie";
import appConfig from "../../config/app-config";
import { createService, instanceService } from "../services/axios";
import store from "../store/store";
import { CheckDevice } from "./check-platform";
import { Platform } from "react-native";

export const ACCESS_TOKEN_COOKIE = "atk";
export const REFRESH_TOKEN_COOKIE = "rtk";

export let instance = instanceService;
export interface ResponseLogin {
  access_token: string;
  expires_in: number;
  "not-before-policy"?: 0;
  refresh_expires_in: number;
  refresh_token: string;
  scope?: string;
  session_state?: string;
  token_type?: string;
}

const cookies = new Cookies();
export function setToken(data: ResponseLogin) {
  if (CheckDevice.isWeb) {
    setCookie(ACCESS_TOKEN_COOKIE, data.access_token, data.expires_in);
    setCookie(REFRESH_TOKEN_COOKIE, data.refresh_token, data.refresh_expires_in);
    instance = createService();
  }
}
export function setCookie(key: string, value: string, expiresIn: number) {
  const date = new Date();
  date.setSeconds(date.getSeconds() + expiresIn);
  const options = {
    path: "/",
  };
  cookies.set(key, value, options);
}

export function getToken(key: string): string {
  try {
    if (CheckDevice.isWeb) {
      return cookies.get(key);
    }
  } catch (error) {
    return "";
  }
  return "";
}

export function removeToken() {
  if (Platform.OS === "web") {
    removeCookie(ACCESS_TOKEN_COOKIE);
    removeCookie(REFRESH_TOKEN_COOKIE);
  }
}

function removeCookie(key: string) {
  return cookies.remove(key, { path: "/" });
}

export async function isTokenValidate(checkUpstream: boolean) {
  const tk = getToken(ACCESS_TOKEN_COOKIE);
  if (!tk || !checkUpstream) return false;

  try {
    if (tk) {
      const config: AxiosRequestConfig = {
        headers: {
          Authorization: `Bearer ${tk}`,
        },
      };
      const response = await instanceService.post(appConfig.userInfoEndpoint, undefined, config);
      console.log("isTokenValidate response: ", response);
      if (response.status === 200) {
        instance = createService();
        // store.dispatch(fetchUserInfoSuccess(response.data));
        return true;
      }
    }
  } catch (e) {
    return await getNewToken();
  }
}

export async function getNewToken() {
  const rtk = getToken(REFRESH_TOKEN_COOKIE);
  const options = {
    headers: { "content-type": "application/x-www-form-urlencoded" },
  };
  const body = {
    client_id: Constants.manifest.extra?.KEYCLOAK_CLIENTID,
    grant_type: "refresh_token",
    refresh_token: rtk,
  };
  try {
    const response = await instanceService.post(appConfig.login, qs.stringify(body), options);
    if (response.status === 200) {
      const data: ResponseLogin = response.data;
      setToken(data);
      // store.dispatch(fetchUserInfoRequest(data.access_token));
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
}
